import { makeActionCreator } from '../../../utilities'
import { PatientDemographicsConstants } from './patientDemographics.constants'

export const setPatientID = makeActionCreator(PatientDemographicsConstants.SET_PATIENT_ID, 'servicePtID')
export const setPatientRunID = makeActionCreator(PatientDemographicsConstants.SET_PATIENT_RUN_ID, 'patientRunID')
export const setTexasWristband = makeActionCreator(PatientDemographicsConstants.SET_TEXAS_WRISTBAND, 'texasWristband')
export const setFirstName = makeActionCreator(PatientDemographicsConstants.SET_FIRST_NAME, 'firstName')
export const setFirstNamePNNV = makeActionCreator(PatientDemographicsConstants.SET_FIRST_NAME_PNNV, 'firstNamePNNV')
export const setMiddleInitial = makeActionCreator(PatientDemographicsConstants.SET_MIDDLE_INITIAL, 'middleInitial')
export const setLastName = makeActionCreator(PatientDemographicsConstants.SET_LAST_NAME, 'lastName')
export const setLastNamePNNV = makeActionCreator(PatientDemographicsConstants.SET_LAST_NAME_PNNV, 'lastNamePNNV')
export const setSuffix = makeActionCreator(PatientDemographicsConstants.SET_SUFFIX, 'suffix')
export const setTriageColor = makeActionCreator(PatientDemographicsConstants.SET_TRIAGE_COLOR, 'triageColor')
export const setTriageColorPNNV = makeActionCreator(
  PatientDemographicsConstants.SET_TRIAGE_COLOR_PNNV,
  'triageColorPNNV'
)
export const setDOB = makeActionCreator(PatientDemographicsConstants.SET_DOB, 'dOB')
export const setDOBPNNV = makeActionCreator(PatientDemographicsConstants.SET_DOB_PNNV, 'dOBPNNV')
export const setAge = makeActionCreator(PatientDemographicsConstants.SET_AGE, 'age')
export const setAgePNNV = makeActionCreator(PatientDemographicsConstants.SET_AGE_PNNV, 'agePNNV')
export const setAgeUnit = makeActionCreator(PatientDemographicsConstants.SET_AGE_UNIT, 'ageUnit')
export const setSSN = makeActionCreator(PatientDemographicsConstants.SET_SSN, 'sSN')
export const setSSNPNNV = makeActionCreator(PatientDemographicsConstants.SET_SSN_PNNV, 'sSNPNNV')
export const setWeight = makeActionCreator(PatientDemographicsConstants.SET_WEIGHT, 'weight')
export const setWeightPNNV = makeActionCreator(PatientDemographicsConstants.SET_WEIGHT_PNNV, 'weightPNNV')
export const setHeight = makeActionCreator(PatientDemographicsConstants.SET_HEIGHT, 'height')
export const setWeightUnits = makeActionCreator(PatientDemographicsConstants.SET_WEIGHT_UNITS, 'weightUnits')
export const setHeightUnits = makeActionCreator(PatientDemographicsConstants.SET_HEIGHT_UNITS, 'heightUnits')
export const setSex = makeActionCreator(PatientDemographicsConstants.SET_SEX, 'sex')
export const setSexPNNV = makeActionCreator(PatientDemographicsConstants.SET_SEX_PNNV, 'sexPNNV')
export const setGender = makeActionCreator(PatientDemographicsConstants.SET_GENDER, 'gender')
export const setGenderPNNV = makeActionCreator(PatientDemographicsConstants.SET_GENDER_PNNV, 'genderPNNV')
export const setRace = makeActionCreator(PatientDemographicsConstants.SET_RACE, 'race')
export const setRacePNNV = makeActionCreator(PatientDemographicsConstants.SET_RACE_PNNV, 'racePNNV')
export const setBloodType = makeActionCreator(PatientDemographicsConstants.SET_BLOOD_TYPE, 'bloodType')
export const setDriversLicense = makeActionCreator(
  PatientDemographicsConstants.SET_DRIVERS_LICENSE_NUMBER,
  'driversLicense'
)
export const setDLState = makeActionCreator(PatientDemographicsConstants.SET_DL_STATE, 'dlState')
export const setAddress1 = makeActionCreator(PatientDemographicsConstants.SET_ADDRESS_1, 'address1')
export const setAddress2 = makeActionCreator(PatientDemographicsConstants.SET_ADDRESS_2, 'address2')
export const setAddressPNNV = makeActionCreator(PatientDemographicsConstants.SET_ADDRESS_PNNV, 'addressPNNV')
export const setZipCode = makeActionCreator(PatientDemographicsConstants.SET_ZIP_CODE, 'zipCode')
export const setCity = makeActionCreator(PatientDemographicsConstants.SET_CITY, 'city')
export const setCityPNNV = makeActionCreator(PatientDemographicsConstants.SET_CITY_PNNV, 'cityPNNV')
export const setState = makeActionCreator(PatientDemographicsConstants.SET_STATE, 'state')
export const setCounty = makeActionCreator(PatientDemographicsConstants.SET_COUNTY, 'county')
export const setCountry = makeActionCreator(PatientDemographicsConstants.SET_COUNTRY, 'country')
export const setResident = makeActionCreator(PatientDemographicsConstants.SET_RESIDENT, 'resident')
export const setAltHomeResidence = makeActionCreator(
  PatientDemographicsConstants.SET_ALT_HOME_RESIDENCE,
  'altHomeResidence'
)
export const setAltHomeResidencePNNV = makeActionCreator(
  PatientDemographicsConstants.SET_ALT_HOME_RESIDENCE_PNNV,
  'altHomeResidencePNNV'
)
export const setCitizenship = makeActionCreator(PatientDemographicsConstants.SET_CITIZENSHIP, 'citizenship')
export const addPhone = makeActionCreator(PatientDemographicsConstants.ADD_PHONE, 'phoneDetails')
export const addEmail = makeActionCreator(PatientDemographicsConstants.ADD_EMAIL, 'emailDetails')
export const setPhoneDetails = makeActionCreator(PatientDemographicsConstants.SET_PHONE_DETAILS, 'phoneDetails')
export const setPhoneDetailsPNNVToggle = makeActionCreator(
  PatientDemographicsConstants.SET_PHONE_DETAILS_PNNV_TOGGLE,
  '__phoneDetailsPNNVToggle'
)
export const setPhoneDetailsPNNV = makeActionCreator(
  PatientDemographicsConstants.SET_PHONE_DETAILS_PNNV,
  'phoneDetailsPNNV'
)
export const setEmailDetails = makeActionCreator(PatientDemographicsConstants.SET_EMAIL_DETAILS, 'emailDetails')
export const savePatientDemographics = makeActionCreator(PatientDemographicsConstants.SAVE_PATIENT_DEMOGRAPHICS)
export const setSavePatientDemographicsResponse = makeActionCreator(
  PatientDemographicsConstants.SET_RESPONSE,
  'response'
)
export const resetState = makeActionCreator(PatientDemographicsConstants.RESET_STATE)
export const setPatientDemographics = makeActionCreator(
  PatientDemographicsConstants.SET_PATIENT_DEMOGRAPHICS,
  'patientDemographics'
)
export const setDnr = makeActionCreator(PatientDemographicsConstants.SET_DNR, 'dnr')
export const setPhysicianData = makeActionCreator(PatientDemographicsConstants.SET_PHYSICIAN_DATA, 'physicianData')
export const addPhysicianList = makeActionCreator(PatientDemographicsConstants.ADD_PHYSICIAN_LIST, 'physicianDataList')
export const addPhysicianData = makeActionCreator(PatientDemographicsConstants.ADD_PHYSICIAN_DATA)
export const setPhysicianFirstName = makeActionCreator(
  PatientDemographicsConstants.SET_PHYSICIAN_FIRSTNAME,
  'physicianFirstName'
)
export const setPhysicianLastName = makeActionCreator(
  PatientDemographicsConstants.SET_PHYSICIAN_LASTNAME,
  'physicianLastName'
)
export const setPhysicianMiddleName = makeActionCreator(
  PatientDemographicsConstants.SET_PHYSICIAN_MIDDLENAME,
  'physicianMiddleName'
)
export const setPhysicianType = makeActionCreator(PatientDemographicsConstants.SET_PHYSICIAN_TYPE, 'physicianType')
export const clearPhysicianData = makeActionCreator(PatientDemographicsConstants.CLEAR_PHYSICIAN_DATA)
export const setBarriersToCare = makeActionCreator(PatientDemographicsConstants.SET_BARRIERS_TO_CARE, 'barriersToCare')
export const setBarriersToCarePNNV = makeActionCreator(
  PatientDemographicsConstants.SET_BARRIERS_TO_CARE_PNNV,
  'barriersToCarePNNV'
)
export const setPreferredLanguage = makeActionCreator(
  PatientDemographicsConstants.SET_PREFERRED_LANGUAGE,
  'preferredLanguage'
)
export const resetEmployer = makeActionCreator(PatientDemographicsConstants.RESET_EMPLOYER)
export const setPatientDemographicsDefaults = makeActionCreator(
  PatientDemographicsConstants.SET_PATIENT_DEMOGRAPHICS_DEFAULTS,
  '__areDefaultsSet'
)

export const getPatientCountyOptions = makeActionCreator(PatientDemographicsConstants.GET_PATIENT_COUNTY_OPTIONS)
